import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31a4e708"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "caseStudies" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "titleWrapper" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "platformTitle" }, "Our Case Studies")
], -1))
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "info" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "stats-info" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = {
  key: 1,
  class: "campaignName"
}
const _hoisted_9 = { class: "counts-wrap video-ads" }
const _hoisted_10 = {
  key: 0,
  class: "counts"
}
const _hoisted_11 = { class: "count" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Influencers", -1))
const _hoisted_13 = {
  key: 1,
  class: "counts"
}
const _hoisted_14 = { class: "count" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Video Ads", -1))
const _hoisted_16 = { class: "counts-wrap" }
const _hoisted_17 = {
  key: 0,
  class: "counts"
}
const _hoisted_18 = { class: "count" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Video Ads", -1))
const _hoisted_20 = {
  key: 1,
  class: "counts"
}
const _hoisted_21 = { class: "count" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Markets", -1))
const _hoisted_23 = {
  key: 2,
  class: "counts"
}
const _hoisted_24 = { class: "count" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Total Clicks", -1))
const _hoisted_26 = {
  key: 3,
  class: "counts"
}
const _hoisted_27 = { class: "count" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Engagement", -1))
const _hoisted_29 = {
  key: 4,
  class: "counts"
}
const _hoisted_30 = { class: "count" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Total Views", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-chevron-left",
  style: {"color":"#fff","font-size":"30px","height":"30px","width":"30px","background":"transparent"}
}, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-chevron-right",
  style: {"color":"#fff","font-size":"30px","height":"30px","width":"30px","background":"transparent"}
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Carousel = _resolveComponent("Carousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", null, [
      _createVNode(_component_Carousel, {
        value: _ctx.carouselItems,
        circular: true,
        numScroll: 1,
        responsiveOptions: _ctx.responsiveOptions,
        showIndicators: false,
        showNavigators: true,
        class: "caseStudies-carousel-wrap"
      }, {
        item: _withCtx((slotProps) => [
          _createElementVNode("div", {
            class: "carousel-item",
            style: _normalizeStyle({ backgroundImage: `url(${slotProps.data.image})` }),
            onClick: ($event: any) => (_ctx.openLink(slotProps.data.link))
          }, [
            _createElementVNode("div", _hoisted_4, [
              (slotProps.data.logo)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: slotProps.data.logo,
                    alt: slotProps.data.campaignName + ' logo',
                    class: "logo"
                  }, null, 8, _hoisted_5))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_6, [
                (slotProps.data.logo)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: slotProps.data.logo,
                      alt: slotProps.data.campaignName + ' logo',
                      class: "logo"
                    }, null, 8, _hoisted_7))
                  : _createCommentVNode("", true),
                (slotProps.data.campaignName)
                  ? (_openBlock(), _createElementBlock("h3", _hoisted_8, _toDisplayString(slotProps.data.campaignName), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_9, [
                  (slotProps.data.influencerCount)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                        _createElementVNode("span", _hoisted_11, _toDisplayString(slotProps.data.influencerCount) + "+", 1),
                        _hoisted_12
                      ]))
                    : _createCommentVNode("", true),
                  (slotProps.data.videoAds && !slotProps.data.influencerCount)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
                        _createElementVNode("span", _hoisted_14, _toDisplayString(slotProps.data.videoAds), 1),
                        _hoisted_15
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  (slotProps.data.videoAds && !slotProps.data.totalClicks)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_17, [
                        _createElementVNode("span", _hoisted_18, _toDisplayString(slotProps.data.videoAds), 1),
                        _hoisted_19
                      ]))
                    : _createCommentVNode("", true),
                  (slotProps.data.marketCount)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_20, [
                        _createElementVNode("span", _hoisted_21, _toDisplayString(slotProps.data.marketCount), 1),
                        _hoisted_22
                      ]))
                    : _createCommentVNode("", true),
                  (slotProps.data.totalClicks)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_23, [
                        _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.formatNumber(slotProps.data.totalClicks)) + "+", 1),
                        _hoisted_25
                      ]))
                    : _createCommentVNode("", true),
                  (slotProps.data.engagement)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_26, [
                        _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.formatNumber(slotProps.data.engagement)) + "+", 1),
                        _hoisted_28
                      ]))
                    : _createCommentVNode("", true),
                  (slotProps.data.totalViews)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_29, [
                        _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.formatNumber(slotProps.data.totalViews)) + "+", 1),
                        _hoisted_31
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ], 12, _hoisted_3)
        ]),
        previousicon: _withCtx(() => [
          _hoisted_32
        ]),
        nexticon: _withCtx(() => [
          _hoisted_33
        ]),
        _: 1
      }, 8, ["value", "responsiveOptions"])
    ])
  ]))
}